import styled from 'styled-components';

export const StyledUsers = styled.div`
    padding: 2rem;
`;
